import { Col, Flex, List, Spin } from "antd";
import React from "react";
import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { useIntl } from "react-intl";
import Empty from "../../../common/Empty";

const AccountingSummary = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();

  const cols = [
    intl.formatMessage({ id: "type" }),
    intl.formatMessage({ id: "total" }),
    data[1]?.month_year,
    data[2]?.month_year,
    data[3]?.month_year,
    data[4]?.month_year,
    data[5]?.month_year,
    data[6]?.month_year,
  ];
  const subtotals: any = ["subtotal"];
  const totalTaxes: any = ["Total Tax"];
  const totalSales: any = ["Total sales"];
  if (Array.isArray(data) && data.length) {
    data?.forEach((item) => {
      console.log(item);
      subtotals.push(item.subtotal);
      totalTaxes.push(item.totalTax);
      totalSales.push(item.totalSales);
    });
  } else {
    console.error("data is not an array or is empty", data);
  }
  console.log([subtotals, totalTaxes, totalSales]);

  return isLoading ? (
    <Spin className="flex items-center justify-center my-4" />
  ) : data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={[subtotals, totalTaxes, totalSales]}
        header={intl.formatMessage({ id: "salesPrimary" })}
      />
    </div>
  ) : (
    <Empty title="لا توجد مبيعات" subTitle="" />
  );
};

export default AccountingSummary;
